import React, { useEffect, useState } from "react";
import PatientService from "../../Services/PatientService";
import StressData from "../../components/Activities/StressData";
import SleepData from "../../components/Activities/SleepData";
import StepData from "../../components/Activities/StepData";
import CaloriesData from "../../components/Activities/CaloriesData";
import BatteryData from "../../components/Activities/BatteryData";
import HRVData from "../../components/Activities/HRVData";

export default function Garmin({ index }) {
  const patJson = localStorage.getItem("patientData");
  const patObj = patJson ? JSON.parse(patJson) : null;
  const visibleCards = 5;
  const cardWidth = 100 / visibleCards;
  const [smartWatchId, setSmartWatchId] = useState("");

  useEffect(() => {
    getSmartWatchId();
  }, []);

  const getSmartWatchId = async () => {
    try {
      const patientRes = await PatientService.getPatient({
        patientId: patObj.patientId,
      });
      const userId = patientRes?.data?.[0]?.smartWatchUserId;
      if (!userId) return;
      setSmartWatchId(userId);
    } catch (error) {}
  };

  // All cards as components
  const cards = [
    // Stress
    <StressData />,

    // Sleep
    <SleepData />,

    // Steps
    <StepData />,

    <CaloriesData />,

    // Body Battery

    <BatteryData />,


    <HRVData />,
  ];

  return (
    <div>
      {smartWatchId && (
        <div className="relative w-full mt-3">
          <div className="overflow-hidden w-full">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{
                transform: `translateX(-${index * (100 / visibleCards + 1)}%)`,
              }}
            >
              {cards.map((card, i) => (
                <div
                  key={i}
                  className="flex-shrink-0"
                  style={{ width: `${cardWidth}%` }}
                >
                  {card}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
